export const getIncrementedNumber = (val) => {
    // Check if the value is numeric
    const value = val?.toString()?.trim();
    if (value === undefined || value === null) {
        return '';
    }
    if (!(isNaN(value) || value?.includes('.'))) {
        return parseInt(value, 10) + 1;
    }

    // If the value is a single letter
    if (value.length === 1 && /[A-Za-z]/.test(value)) {
        return String.fromCharCode(value.charCodeAt(0) + 1);
    }

    const regex = /^(.*?)(\d+)$/;
    const match = value.match(regex);

    if (match) {
        const letters = match[1];
        const number = match[2] ? parseInt(match[2], 10) + 1 : 1;

        return letters + number;
    }

    // Return the input if it doesn't match any known pattern
    return value;
}

export const getIncrementedBookCode = (value) => {
    // Check if the value is numeric
    if (!value?.toString()?.trim()) {
        return 1;
    }

    if (!isNaN(value)) {
        return parseInt(value, 10) + 1;
    }
    // Return the input if it doesn't match any known pattern
    return value;
}